import {Type} from "class-transformer";

class ProfileTranslation {
    locale!: string;
    description!: string;
    short_description!: string;
}

class Profile {
    profile_image!: string;
    slug!: string;
    name!: string;

    @Type(() => ProfileTranslation)
    profile_translations!: ProfileTranslation[]

    public GetProfileImage(): string {
        if (!this.profile_image.startsWith("https://")) {
            return `https://zcg.imgix.net/${this.profile_image}`
        }
        return this.profile_image
    }
}

class Consultant {

    @Type(() => Profile)
    profile!: Profile;

    id!: number;
    box_number!: number;
    status!: number;

    rating!: number;
    average_rating!: number;
    review_count!: number;

    call_enabled!: boolean;
    call_rate!: number;

    chat_enabled!: boolean;
    chat_rate!: number;

}

export default Consultant;